import { User } from '..';

export const emptyUser: User = {
  birthDate: '',
  contactPhotoFilename: '',
  // @ts-expect-error
  status: null,
  companies: [],
  emails: [],
  firstName: '',
  // @ts-expect-error
  uuid: null,
  language: '',
  lastName: '',
  password: '',
  roleUnits: [],
  phones: [],
  // @ts-expect-error
  timezone: {},
  title: '',
  username: '',
  projectTeamMembers: [],
  capacity: 35,
  // @ts-expect-error
  currentBillableRate: null,
  hasActiveTimeTracks: false,
  billableRates: [],
  // @ts-expect-error
  costRate: null,
  // @ts-expect-error
  socialSecurityNumber: null,
};
